import src from "IMAGE";
export default { src, width: 110, height: 110, blurWidth: 0, blurHeight: 0};
